export default __webpack_public_path__ + "static/media/athena-logo.9ad9f981.png";